var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomizeList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.748,
    height: 17.997,
    viewBox: "0 0 17.748 17.997",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.696,
    height: 1.099,
    transform: "translate(2.798 2.497)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1296.307-373.015a7.091,7.091,0,0,0-1.51,1.1h-3.728v-1.1Z",
    transform: "translate(1304.343 378.409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1299.256-370.018a6.231,6.231,0,0,0-.46,1.1h-1.789v-1.1Z",
    transform: "translate(1304.343 378.409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1304.343-378.409v17.98h7.816a6.733,6.733,0,0,1-1.44-1.1h-5.247V-377.31h11.734v3.546a6.058,6.058,0,0,1,1.129.32v-4.965Z",
    transform: "translate(1304.343 378.409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1292.85-368.947a2.3,2.3,0,0,0-2.29,2.29,2.3,2.3,0,0,0,2.29,2.29,2.29,2.29,0,0,0,2.29-2.29A2.29,2.29,0,0,0-1292.85-368.947Zm0,3.476a1.186,1.186,0,0,1-1.187-1.186,1.186,1.186,0,0,1,1.187-1.187,1.186,1.186,0,0,1,1.186,1.187A1.185,1.185,0,0,1-1292.85-365.471Z",
    transform: "translate(1304.343 378.409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1288.083-366.657l.229-.167,1.259-.936-1.041-2.54-1.561.24-.281.041.042-.281.239-1.561-2.54-1.051-.947,1.27-.166.218-.167-.218-.936-1.27-2.53,1.051.229,1.561.042.281-.271-.041-1.561-.24-1.051,2.54,1.27.936.218.167-.218.167-1.27.936,1.051,2.529,1.561-.229.271-.041-.042.281-.229,1.551,2.53,1.051.947-1.26.166-.229.167.229.936,1.26,2.53-1.041-.229-1.561-.042-.281.281.041,1.551.24,1.051-2.54-1.259-.936Zm.083,1.624-.271.645-.062.146-.156-.021-1.28-.187-.2.228a3.251,3.251,0,0,1-.427.427l-.239.2.2,1.291.021.156-.156.062-.645.271-.146.062-.1-.135-.77-1.041-.3.031a2.775,2.775,0,0,1-.3.011,2.684,2.684,0,0,1-.3-.011l-.3-.021-.771,1.031-.1.135-.145-.062-.646-.271-.156-.062.021-.156.2-1.281-.229-.2a4.306,4.306,0,0,1-.437-.438l-.2-.228-1.28.187-.156.031-.063-.156-.271-.645-.062-.156.125-.094,1.041-.77-.021-.3a3,3,0,0,1,0-.614l.021-.3-1.031-.77-.135-.094.062-.156.271-.645.063-.146.156.021,1.28.187.2-.229a3.383,3.383,0,0,1,.437-.427l.229-.2-.188-1.281-.02-.166.145-.063.656-.27.146-.063.093.136.771,1.04.3-.02a2.98,2.98,0,0,1,.313-.011,2.859,2.859,0,0,1,.3.011l.3.02.77-1.04.094-.125.156.062.646.26.156.063-.032.166-.187,1.281.229.2a3.383,3.383,0,0,1,.437.427l.2.239,1.28-.2.156-.021.063.146.27.655.063.146-.136.1-1.04.77.021.3a3.044,3.044,0,0,1,0,.6l-.021.3,1.04.77.125.094Z",
    transform: "translate(1304.343 378.409)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomizeList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/customize-list.544bc0f9fda7bd8be9e55bf7c088525a.svg";